import { Spinner } from "@/modules/shadcn/ui/spinner";
import { Camera } from "lucide-react";
import { useTranslation } from "react-i18next";

export interface SearchingForCameraProps {
  url?: string | null;
  /**
   * Tightens spacing and type so the screen fits inside the 16:9 preview box
   * (Run → Inference) instead of owning the whole page (Capture).
   */
  compact?: boolean;
}

export const SearchingForCamera = ({ url, compact }: SearchingForCameraProps) => {
  const { t } = useTranslation("camera");
  const cx = {
    root: compact
      ? "flex h-full flex-1 flex-col items-center justify-center overflow-y-auto p-6 text-center"
      : "flex flex-1 flex-col items-center justify-center p-8",
    icon: compact
      ? "mb-4 h-14 w-14 [&_svg]:size-6"
      : "mb-6 h-20 w-20 [&_svg]:size-8",
    title: compact ? "mb-1 text-base" : "mb-2 text-xl",
    description: compact ? "mb-4 text-xs" : "mb-6 text-sm",
    url: compact ? "mt-4" : "mt-6",
  };

  return (
    <div className={cx.root}>
      <div
        className={`flex items-center justify-center rounded-full bg-black/5 [&_svg]:text-black/60 ${cx.icon}`}
      >
        <Camera />
      </div>

      <p className={`font-semibold text-black ${cx.title}`}>
        {t("connection.searching.title")}
      </p>

      <p className={`text-black/60 ${cx.description}`}>
        {t("connection.searching.description")}
      </p>

      <Spinner />

      {url && (
        <p className={`font-mono text-xs text-black/40 ${cx.url}`}>
          {t("connection.searching.trying", { url })}
        </p>
      )}
    </div>
  );
};
